<template>
  <div class="home-wrapper">
    <div class="banner">
      <div class="logo"></div>
    </div>
    <div class="time">
      <h1>什么是TIME生态合作伙伴计划
        <i class="border" style="width:135px"></i>
      </h1>
      <p class="info">TIME计划是由腾讯智慧出行发起，联合腾讯云启产业生态平台、腾讯研究院、腾讯大学，以及车企软硬件合作伙伴、高校机构等，共同发起的智慧出行产业生态创新计划。</p>
      <p class="txt">“TIME”寓意“智慧出行产业升级正当时”T-Talent人才培养，I-Incubator投资孵化，M-Mutual Benefit互惠互利，E-Enlighten点亮商机通过打通腾讯及合作伙伴在出行领域的技术、产品、平台等能力，整合资本、商机、培训、营销等资源，以产孵、产投、产培、产服为“四大引擎”，构建灵活、开放的生态平台，全方位助推智慧出行产业创新。</p>
      <div class="imglist_box">
        <ul class="imglist">
          <li>
            <div class="c_img"><img src="./img/time_1.png" alt=""></div>
            <p class="title">共享商机</p>
            <p class="imgtxt">共享潜在客户资源与销售渠道，打造联合解决方案共享客户商机。</p>
          </li>
          <li>
            <div class="c_img"><img src="./img/time_2.png" alt=""></div>
            <p class="title">优惠用云</p>
            <p class="imgtxt">根据伙伴类型，为出行伙伴提供特别优惠政策与上云技术支持。</p>
          </li>
          <li>
            <div class="c_img"><img src="./img/time_3.png" alt=""></div>
            <p class="title">营销推广</p>
            <p class="imgtxt">峰会活动交流、标杆案例宣传联合市场推广官网品牌曝光，助力合作伙伴拓展市场。</p>
          </li>
          <li>
            <div class="c_img"><img src="./img/time_4.png" alt=""></div>
            <p class="title">培训赋能</p>
            <p class="imgtxt">来自腾讯大学、腾讯出行学院的产业专家、知名投资人、行业知名创业者、腾讯高管做导师产培赋能。</p>
          </li>
          <li>
            <div class="c_img"><img src="./img/time_5.png" alt=""></div>
            <p class="title">技术支持</p>
            <p class="imgtxt">获得腾讯各大实验室技术、云能力赋能，提供项目指导、测试支持。</p>
          </li>
          <li>
            <div class="c_img"><img src="./img/time_6.png" alt=""></div>
            <p class="title">投资孵化</p>
            <p class="imgtxt">优先获得投资机会。联合腾讯战投与VC联盟资本加速合作落地。</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="bg_box">
      <h1>率先开启智能座舱赛道
        <i class="border" style="width:245px;margin-top:20px"></i> 
      </h1>
      <div class="dev_box">
        <span class="button_span">小场景开发者</span>
        <p class="dev_txt">“腾讯小场景”是适合车载体验的轻应用生态，无需下载安装轻松唤起即用即走。通过一套轻量化易适配的框架，将车与互联网开放生态相连接让腾讯与开发者一起满足用户在车上的丰富场景。</p>
        <div class="c_dev">
          <h2>4步完成小场景发布</h2>
          <ul class="dev_step">
            <li><span>01</span>注册认证</li>
            <li><i></i></li>
            <li><span>02</span>创建</li>
            <li><i></i></li>
            <li><span>03</span>开发</li>
            <li><i></i></li>
            <li><span>04</span>交付发布</li>
          </ul>
          <a class="button" href="https://developer.tai.qq.com/">立即注册</a>
        </div>
        <div class="c_oem">
          <h2>4步成为智能座舱合作伙伴</h2>
          <ul class="devimg">
            <li><img src="./img/dev_1.png" alt=""><span class="button_span">硬件系统</span></li>
            <li><img src="./img/dev_2.png" alt=""><span class="button_span">车载OS</span></li>
            <li><img src="./img/dev_3.png" alt=""><span class="button_span">芯片</span></li>
          </ul>
          <ul class="dev_step">
            <li><span>01</span>提交合作申请</li>
            <li><i></i></li>
            <li><span>02</span>伙伴资质审核</li>
            <li><i></i></li>
            <li><span>03</span>业务沟通</li>
            <li><i></i></li>
            <li><span>04</span>成为TIME合作伙伴</li>
          </ul>
          <a class="button" @click="ShowDialog">立即申请</a>
        </div>
      </div>
    </div>
    <div class="bottom">
      <h1>腾讯智慧出行部分合作伙伴<span class="sort">*首字母顺序排列，排名不分先后</span></h1>
      <ul>
        <li v-for="(img, i) in partnerImgList[0].imgList" :key="i"><img :src="img" alt="logo"></li>
      </ul>
      <!-- <el-tabs v-model="activeName">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in partnerImgList" :key="index" lazy>
          <ul>
            <li v-for="(img, i) in item.imgList" :key="i"><img :src="img" alt="logo"></li>
          </ul>
        </el-tab-pane>
      </el-tabs> -->
    </div>

    <el-dialog title="合作咨询" :visible.sync="isShowDialog" :close-on-click-modal="false" destroy-on-close>
      <Consulting @close="isShowDialog=false"/>
    </el-dialog>
  </div>
</template>

<script>
import Consulting from '@/components/consulting';
  export default {
    name: 'home',
    components: {
      Consulting,
    },
    data() {
      return {
        isShowDialog: false,
        formValue:{},
        rules:{},
        activeName:"A",
        partnerImgList:[
          {
            name:"A",
            label:"OEM",
            imgList:[
              require('../../assets/home/A/A-1.png'),
              require('../../assets/home/A/A-2.png'),
              require('../../assets/home/A/A-3.png'),
              require('../../assets/home/A/A-4.png'),
              require('../../assets/home/A/A-5.png'),
              require('../../assets/home/A/A-6.png'),
              require('../../assets/home/A/A-7.png'),
              require('../../assets/home/A/A-8.png'),
              require('../../assets/home/A/A-9.png'),
              require('../../assets/home/A/A-10.png'),
              require('../../assets/home/A/A-11.png'),
              require('../../assets/home/A/A-12.png'),
              require('../../assets/home/A/A-13.png'),
              require('../../assets/home/A/A-14.png'),
              require('../../assets/home/A/A-15.png'),
              require('../../assets/home/A/A-16.png'),
            ]
          }
          // ,{
          //   name:"B",
          //   label:"智能座舱",
          //   imgList:[
          //     require('../../assets/home/B/B-1.png'),
          //     require('../../assets/home/B/B-2.png'),
          //     require('../../assets/home/B/B-3.png'),
          //     require('../../assets/home/B/B-4.png'),
          //     require('../../assets/home/B/B-5.png'),
          //   ]
          // },{
          //   name:"C",
          //   label:"车载小场景",
          //   imgList:[
          //     require('../../assets/home/C/C-1.png'),
          //     require('../../assets/home/C/C-2.png'),
          //     require('../../assets/home/C/C-3.png'),
          //     require('../../assets/home/C/C-4.png'),
          //     require('../../assets/home/C/C-5.png'),
          //     require('../../assets/home/C/C-6.png'),
          //     require('../../assets/home/C/C-7.png'),
          //     require('../../assets/home/C/C-8.png'),
          //     require('../../assets/home/C/C-9.png'),
          //     require('../../assets/home/C/C-10.png'),
          //     require('../../assets/home/C/C-11.png'),
          //     require('../../assets/home/C/C-12.png'),
          //     require('../../assets/home/C/C-13.png'),
          //     require('../../assets/home/C/C-14.png'),
          //     require('../../assets/home/C/C-15.png'),
          //     require('../../assets/home/C/C-16.png'),
          //     require('../../assets/home/C/C-17.png'),
          //     require('../../assets/home/C/C-18.png'),
          //     require('../../assets/home/C/C-19.png'),
          //     require('../../assets/home/C/C-20.png'),
          //     require('../../assets/home/C/C-21.png'),
          //     require('../../assets/home/C/C-22.png'),
          //     require('../../assets/home/C/C-23.png'),
          //     require('../../assets/home/C/C-24.png'),
          //     require('../../assets/home/C/C-25.png'),
          //     require('../../assets/home/C/C-26.png'),
          //     require('../../assets/home/C/C-27.png'),
          //     require('../../assets/home/C/C-28.png'),
          //     require('../../assets/home/C/C-29.png'),
          //     require('../../assets/home/C/C-30.png'),
          //     require('../../assets/home/C/C-31.png'),
          //     require('../../assets/home/C/C-32.png'),
          //     require('../../assets/home/C/C-33.png'),
          //     require('../../assets/home/C/C-34.png'),
          //     require('../../assets/home/C/C-35.png'),
          //     require('../../assets/home/C/C-36.png'),
          //     require('../../assets/home/C/C-37.png'),
          //     require('../../assets/home/C/C-38.png'),
          //     require('../../assets/home/C/C-39.png'),
          //     require('../../assets/home/C/C-40.png'),
          //     require('../../assets/home/C/C-41.png'),
          //     require('../../assets/home/C/C-42.png'),
          //     require('../../assets/home/C/C-43.png'),
          //     require('../../assets/home/C/C-44.png'),
          //     require('../../assets/home/C/C-45.png'),
          //     require('../../assets/home/C/C-46.png'),
          //     require('../../assets/home/C/C-47.png'),
          //     require('../../assets/home/C/C-48.png'),
          //     require('../../assets/home/C/C-49.png'),
          //     require('../../assets/home/C/C-50.png'),
          //     require('../../assets/home/C/C-51.png'),
          //     require('../../assets/home/C/C-52.png'),
          //     require('../../assets/home/C/C-53.png'),
          //     require('../../assets/home/C/C-54.png'),
          //     require('../../assets/home/C/C-55.png'),
          //     require('../../assets/home/C/C-56.png'),
          //     require('../../assets/home/C/C-57.png'),
          //     require('../../assets/home/C/C-58.png'),
          //     require('../../assets/home/C/C-59.png'),
          //     require('../../assets/home/C/C-60.png'),
          //     require('../../assets/home/C/C-61.png'),
          //     require('../../assets/home/C/C-62.png'),
          //     require('../../assets/home/C/C-63.png'),
          //     require('../../assets/home/C/C-64.png'),
          //     require('../../assets/home/C/C-65.png'),
          //     require('../../assets/home/C/C-66.png'),
          //     require('../../assets/home/C/C-67.png'),
          //     require('../../assets/home/C/C-68.png'),
          //     require('../../assets/home/C/C-69.png'),
          //     require('../../assets/home/C/C-70.png'),
          //     require('../../assets/home/C/C-71.png'),
          //     require('../../assets/home/C/C-72.png'),
          //   ]
          // },{
          //   name:"D",
          //   label:"数字营销",
          //   imgList:[
          //     require('../../assets/home/D/D-1.png'),
          //     require('../../assets/home/D/D-2.png'),
          //     require('../../assets/home/D/D-3.png'),
          //     require('../../assets/home/D/D-4.png'),
          //     require('../../assets/home/D/D-5.png'),
          //     require('../../assets/home/D/D-6.png'),
          //     require('../../assets/home/D/D-7.png'),
          //     require('../../assets/home/D/D-8.png'),
          //   ]
          // },{
          //   name:"E",
          //   label:"自动驾驶",
          //   imgList:[
          //     require('../../assets/home/E/E-1.png'),
          //     require('../../assets/home/E/E-2.png'),
          //     require('../../assets/home/E/E-3.png'),
          //     require('../../assets/home/E/E-4.png'),
          //     require('../../assets/home/E/E-5.png'),
          //     require('../../assets/home/E/E-6.png'),
          //     require('../../assets/home/E/E-7.png'),
          //   ]
          // },{
          //   name:"F",
          //   label:"出行服务",
          //   imgList:[
          //     require('../../assets/home/F/F-1.png'),
          //     require('../../assets/home/F/F-2.png'),
          //     require('../../assets/home/F/F-3.png'),
          //     require('../../assets/home/F/F-4.png'),
          //     require('../../assets/home/F/F-5.png'),
          //     require('../../assets/home/F/F-6.png'),
          //     require('../../assets/home/F/F-7.png'),
          //     require('../../assets/home/F/F-8.png'),
          //     require('../../assets/home/F/F-9.png'),
          //     require('../../assets/home/F/F-10.png'),
          //     require('../../assets/home/F/F-11.png'),
          //     require('../../assets/home/F/F-12.png'),
          //     require('../../assets/home/F/F-13.png'),
          //     require('../../assets/home/F/F-14.png'),
          //     require('../../assets/home/F/F-15.png'),
          //     require('../../assets/home/F/F-16.png'),
          //     require('../../assets/home/F/F-17.png'),
          //     require('../../assets/home/F/F-18.png'),
          //     require('../../assets/home/F/F-19.png'),
          //     require('../../assets/home/F/F-20.png'),
          //   ]
          // }
        ]
      }
    },
    methods:{
      ShowDialog(){
        this.isShowDialog=true
      }
    }
  }
</script>
<style lang="scss" scoped>
  .el-dialog__wrapper{
    /deep/ .el-dialog__header{
      text-align: center;
      font-weight: 700;
    }
    /deep/.el-dialog__body{
      padding-top:20px;
    }
  }
  /deep/ .el-tabs__header{
    margin-bottom: 60px;
    .el-tabs__nav-wrap::after{
      display: none;
    }
  }
  .bottom{
    width: 1280px;
    padding: 90px 0 100px;
    margin: 0 auto;
    h1{
      text-align: left;
      margin-bottom: 60px;
    }
    .sort{
      font-size: 16px;
      margin-left: 20px;
      color: #666;
      vertical-align: bottom;
    }
    ul{
      display: flex;
      flex-wrap: wrap;
      margin-left: -30px;
      li{
        flex: 0;
        height: 140px;
        max-width: 25%;
        min-width: 295px;
        margin-bottom: 30px;
        margin-left: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #dcdcdc;
        cursor: pointer;
        &:hover{
          box-shadow: 0 0 20px 10px rgba(150,191,248,.15);
          border: 1px solid transparent;
        }
      }
    }
  }
  .button{
    display: block;
    width: 230px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    color:#fff;
    font-size: 24px;
    margin: 0 auto;
    background-color: #006ae0;
    cursor: pointer;
  }
  .button_span{
    display: block;
    position: absolute;
    width: 200px;
    height: 45px;
    top:20px;
    right: 20px;
    background-color: #fff;
    color: #151b25;
    font-size: 14px;
    font-weight: 500;
    line-height: 45px;
    text-align: center;
  }
  .dev_box{
    position: relative;
    width: 1280px;
    padding-top: 250px;
    margin: 55px auto 0;
    background: url(./img/dev_bg.png) no-repeat center top;
    .c_dev{
      width:1190px;
      margin: 0px auto;
      padding:30px 0 45px;
      background-color: #fff;
      box-shadow: 2px 2px 8px 8px rgba(150,191,248,.15)
    }
    .c_oem{
      margin: 120px auto 0;
      padding:30px 0 45px;
      background-color: #fff;
      box-shadow: 2px 2px 8px 8px rgba(150,191,248,.15);
      .devimg{
        padding-left: 30px;
        margin: 40px 0 60px;
        li{
          display: inline-block;
          position: relative;
          width: 386px;
          height: 223px;
          margin-right: 30px;
          img{
            width:100%;
            height: 100%;
          }
          .button_span{
            width:130px;
          }
        }
      }
      .dev_step{
        i::after{
          display: none;
        }
      }
    }
    .dev_txt{
      text-indent: 2em;
      font-size: 16px;
      line-height: 24px;
      color: #fefefe;
      width: 480px;
      margin: 0 auto 40px;
    }
    h2{
      text-align: center;
      font-weight: 500;
      font-size: 30px;
      color: #000;
    }
    .dev_step{
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 40px 0 50px;
      li{
        align-items: center;
        display: flex;
        font-size: 24px;
        color: #333333;
        margin: 0 10px;
        span{
          font-size: 30px;
          color: #006ae0;
          margin-right: 10px;
        }
        i{
          height: 2px;
          background-color: #000;
          width: 90px;
          display: inline-block;
          vertical-align: middle;
          position: relative;
          &::after{
            position: absolute;
            content: "";
            height: 6px;
            width: 6px;
            border-radius: 50%;
            background: #000;
            top: -2px;
            right: 0px;
          }
        }
      }
    }
  }
  .home-wrapper{
    min-width: 1600px;
  }
 .banner{
   height: 600px;
   background:url('./img/banner.gif') no-repeat center top #bdd2e9;
 }
 .logo{
   width:1280px;
   height: 100%;
   margin:0 auto;
   background:url('./img/logo.png') no-repeat left 35px transparent;
 }
 h1{
   font-size: 36px;
   font-weight: 500;
   color: #151b25;
   text-align: center;
   .border{
     display: block;
     margin: 30px auto 0;
     height: 6px; 
     background-color: #006ae0;
   }
 }
 .time{
   margin-top: -65px;
   margin-left: auto;
   margin-right: auto;
   position: relative;
   z-index: 10;
   width: 1600px;
   padding: 60px 0 40px;
   background-color: #fff;
   .info{
     margin: 35px auto 0;
     font-size: 18px;
     color:#141b24;
     line-height: 30px;
     width:825px;
     text-align: center;
   }
   .txt{
      margin: 25px auto 0;
      font-size: 16px;
      color:#6b798e;
      line-height: 30px;
      width:1000px;
      text-align: center;
   }
   .imglist_box{
      margin: 80px auto 0;
      width:1280px;
   }
   .imglist{
      display: flex;
      flex-wrap: wrap;
      justify-content:space-between;
      flex-wrap: wrap;
      margin-left: -160px;
     li{
      text-align: center;
      width: 320px;
      height: 400px;
      margin-left: 160px;
     }
     .c_img{
       height: 200px;
       line-height: 200px;
     }
     .title{
        color: #151b25;
        font-size: 26px;
        margin: 20px 0 30px;
     }
     .imgtxt{
        font-size: 16px;
        color:#6b798e;
        line-height: 24px;
     }
   }
 }
 .bg_box{
   padding: 90px 0 130px;
   background-color: #f7f8fa;
 }
@media screen and (max-width: 1600px){
  .home-wrapper{
    min-width: 1280px;
  }
  .time{
    width:1280px;
  }
}
</style>